<template>
  <div class="border-t-sm d-flex flex-column">
    <VListItem
      :title="$t('words.logOut')"
      prependIcon="logout"
      class="text-error my-2"
      @click="toggleIsOpen"
    />

    <VListItem size="small" class="text-center pa-0 text-gray-400">
      <small class="d-flex justify-center ga-1 text-center">
        <div v-if="!rail">
          {{ $t('produceBy') }}
        </div>

        <a
          href="https://www.faramaham.com/"
          target="_blank"
          class="text-center pa-0 text-gray-400"
        >
          {{ $t('projectOwnerTitle') }}
        </a>
      </small>
    </VListItem>
  </div>

  <BaseConfirmationModal
    v-model="isOpen"
    color="error"
    :title="$t('exitTitle')"
    :description="$t('exitDescription')"
    :state="ConfirmationState.Logout"
    @update:is-open="toggleIsOpen"
    @on-submit="logout"
  />
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import { VListItem } from 'vuetify/components'
import type { Props } from './TheSideBarFooter.types'
import BaseConfirmationModal from '../../../base/BaseConfirmationModal/BaseConfirmationModal.vue'
import useAuthStore from '@/modules/Auth/store'
import router from '@/router'
import { ConfirmationState } from '@/modules/Core/types/model/confirmationModal'

defineProps<Props>()

const isOpen = ref(false)

function toggleIsOpen() {
  isOpen.value = !isOpen.value
}

const authStore = useAuthStore()
async function logout() {
  authStore.logout()
  toggleIsOpen()
  router.push('/login')
}
</script>
